
import Mintpage from "../comp/MintPage/MintPage"


const Mint = () => {
    return (
        <div>

            <Mintpage></Mintpage>
        </div>
    )
}

export default Mint;